var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8454 2.88484C15.513 2.48677 16.0471 1.8565 16.2808 1.09353C15.6466 1.45843 14.9455 1.72381 14.1777 1.88967C13.5768 1.2594 12.7089 0.861328 11.7742 0.861328C9.97154 0.861328 8.50272 2.32091 8.50272 4.11221C8.50272 4.37759 8.5361 4.6098 8.60286 4.842C5.89889 4.70931 3.46197 3.41559 1.82623 1.42526C1.55917 1.92284 1.39226 2.4536 1.39226 3.0507C1.39226 4.17856 1.95976 5.17373 2.86109 5.77083C2.32697 5.73765 1.82623 5.60497 1.35888 5.37276V5.40593C1.35888 6.9982 2.49388 8.32509 3.99609 8.62364C3.72903 8.68999 3.42859 8.72316 3.12814 8.72316C2.92785 8.72316 2.69417 8.68999 2.49388 8.65682C2.92785 9.95053 4.12962 10.9125 5.56506 10.9125C4.43006 11.775 3.028 12.3058 1.49241 12.3058C1.22535 12.3058 0.958286 12.3058 0.724609 12.2726C2.19344 13.2014 3.89594 13.7322 5.76536 13.7322C11.8076 13.7322 15.1124 8.75633 15.1124 4.44393C15.1124 4.31125 15.1124 4.14538 15.1124 4.0127C15.7467 3.58146 16.3142 3.01753 16.7482 2.35408C16.1473 2.61946 15.513 2.78532 14.8454 2.88484Z",
    fill: "#FD6003"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0236,
    height: 12.8708,
    fill: "white",
    transform: "translate(0.724609 0.861328)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fec46563f154eb32a618ad2a0b440d72.svg";
export { ForwardRef as ReactComponent };